/**
 * Actions for the different zones.
 *
 * @type {Object}
 */
Game.Utils.MapZonesActions = {


	/**
	 * Set skier to walk mode.
	 *
	 * @param  {skier} skier The skier who should be walking.
	 * @param  {object} zone The zone data.
	 */
	walk: function( skier, zone ) {

		// If we're not skiing, ie we're jumping, then let's quit. We don't care
		// about walking in this case.
		if ( ! skier.alive ) {
			return;
		}

		if ( ! skier.is_skiing() ) {
			return;
		}

		skier.state = Game.Prefabs.Man.states.WALK;

	},


	/**
	 * Enter a door.
	 *
	 * @param  {skier} skier The skier who is entering the door.
	 * @param  {object} zone The zone data.
	 */
	door_old: function( skier, zone ) {

		var type = 'world';
		var path = 'world';
		var checkpoint = '';

		if ( Game.Utils.Map.zone_has_property( zone, 'room' ) ) {
			type = 'room';
			path = 'rooms/' + zone.properties.room;
		}

		if ( Game.Utils.Map.zone_has_property( zone, 'checkpoint' ) ) {
			checkpoint = zone.properties.checkpoint;
		}

		game.state.start(
			'load-world',
			true,
			false,
			{
				'path': path,
				'type': type,
				'checkpoint': checkpoint
			}
		);

	},


	door: function( player, zone ) {

		if ( zone.callback && undefined !== typeof Game.Utils.callbacks[zone.callback] ) {

			Game.Utils.callbacks[zone.callback]( zone );
			return;

		}

		if ( Game.Utils.Inventory.haveItem( 'key/' + zone.name ) ) {

			zone.door.open();

		}

	},


	/**
	 * Display a signpost message.
	 *
	 * @param  {skier} skier The skier who is reading the signpost.
	 * @param  {object} zone The zone data.
	 */
	computer: function( player, zone ) {

		if ( zone.name ) {

			var key = zone.name;

			if ( Game.JSON.signposts[ key ] ) {

				Game.Utils.Signposts.display( Game.JSON.signposts[ key ], zone );

			}

		}

	},


	/**
	 * Temporary time trial.
	 *
	 * @param  {skier} skier The skier.
	 * @param  {object} zone The zone data.
	 */
	timetrial: function( skier, zone ) {

		game.state.start(
			'time-trial'
		);

	},


};
